import React from "react";

import "./ImgBodySection.css";
import Modal from "../Modal/Modal";

const ImgBodySection = ({ title, img }) => {
  return (
    <>
      <div className="content-img-about">
        {/* Title of the box, on the left side */}
        <div className="title-img-about">
          <h4>{title}</h4>
        </div>

        {/* Body of the box, on the right side */}
        <div className="who-body">
          <img src={img} alt="" srcset="" />
          <Modal />
        </div>
      </div>
    </>
  );
};

export default ImgBodySection;
